import * as $ from 'jquery';

import { unique } from 'lib/util/array';

import { AbstractProviderConfig } from '../Tc.Module.TemplatingContainer';

export interface SegmentMappingProviderConfig extends AbstractProviderConfig {
	type : 'segmentMapping';
	segmentUrl? : string;
	mappingUrl : string;
	fieldName : string;
}

const RESPONSES : {
	[key : string] : Promise<any>;
} = {};

export function clearResponseCacheForTesting() {
	for(const url in RESPONSES) {
		// tslint:disable-next-line:no-dynamic-delete
		delete RESPONSES[url];
	}
}

function load(url : string, segments : string[] | null) {
	const key = segments && segments.length ? `${url}/${segments.join('.')}` : url;
	if(key in RESPONSES) {
		return RESPONSES[key];
	}
	RESPONSES[key] = $.ajax({
		data: segments === null ? '' : {tntSegments : segments},
		dataType: 'json',
		type: segments === null ? 'get' : 'post',
		url,
		xhrFields: {
			withCredentials: true,
		},
	});

	return RESPONSES[key];
}

async function getSegments(url : string) : Promise<string[]> {
	if('EXPERIENCES_PREVIEW_CURRENT_SEGMENTS' in window) {
		return (window as any).EXPERIENCES_PREVIEW_CURRENT_SEGMENTS;
	}

	const segmentConfig = await load(url || 'https://swisscom.demdex.net/event?&d_rtbd=json&d_cts=2', null);

	return (segmentConfig || {}).segments || [];
}

export async function segmentMappingProvider(config : SegmentMappingProviderConfig) {
	const segments = unique(
		await getSegments(config.segmentUrl || 'https://swisscom.demdex.net/event?&d_rtbd=json&d_cts=2'),
	).sort();

	if(!segments.length || !config.fieldName) {
		return null;
	}

	const url = `${config.mappingUrl}/_jcr_content.segments.json`;

	try {
		const mapping = await load(url, segments);

		return mapping[config.fieldName] as string;
	} catch(e) {
		console.warn(`Error loading segment mapping from ${config.mappingUrl}`, e);

		return null;
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/personalization/templating/providers/segmentMapping.ts